/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const LayoutLogoIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 166 166"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-1322.91,-961.802)">
      <g transform="matrix(0.742191,0,0,0.742191,886.437,-933.206)">
        <g transform="matrix(0.682377,0,0,0.682377,376.383,2501.7)">
          <path
            d="M636.644,134.398L636.644,343.126C636.644,375.596 610.282,401.958 577.812,401.958L369.084,401.958C336.614,401.958 310.252,375.596 310.252,343.126L310.252,134.398C310.252,101.928 336.614,75.566 369.084,75.566L577.812,75.566C610.282,75.566 636.644,101.928 636.644,134.398Z"
            style={{ fill: 'rgb(44,94,75)' }}
          />
          <clipPath id="_clip1">
            <path d="M636.644,134.398L636.644,343.126C636.644,375.596 610.282,401.958 577.812,401.958L369.084,401.958C336.614,401.958 310.252,375.596 310.252,343.126L310.252,134.398C310.252,101.928 336.614,75.566 369.084,75.566L577.812,75.566C610.282,75.566 636.644,101.928 636.644,134.398Z" />
          </clipPath>
          <g clipPath="url(#_clip1)">
            <rect x="310.252" y="75.566" width="326.392" height="326.392" style={{ fill: 'url(#_Linear2)' }} />
            <g transform="matrix(1,0,0,1,-10.4843,4.33743)">
              <g transform="matrix(-0.249851,0.249851,-1.36428e-15,2.18891,1080.94,-1160.65)">
                <path
                  d="M2035.48,396.128L2145.69,370.969L2265.5,370.969L2265.5,357.31L2145.69,357.31L1838.1,427.528L2180.1,388.563L2179.47,379.692L2035.48,396.128Z"
                  style={{ fill: 'white' }}
                />
              </g>
              <g transform="matrix(0.977236,0,0,0.977236,423.001,285.798)">
                <path
                  d="M-146.059,15.022L0,-131.212L145.708,14.889L-146.059,15.022ZM-96.694,-3.216L-28.141,-3.247L-62.376,-37.574L-96.694,-3.216ZM9.645,-90.474L9.679,-15.259L47.342,-52.821L9.645,-90.474ZM28.494,-3.216L97.046,-3.247L62.811,-37.574L28.494,-3.216ZM-9.645,-90.474L-47.342,-52.821L-9.679,-15.259L-9.645,-90.474Z"
                  style={{ fill: 'white' }}
                />
              </g>
              <g transform="matrix(0.977236,0,0,0.977236,484.631,285.179)">
                <path
                  d="M27.945,-22.353L-40.827,-90.345L0,-131.212L108.431,-22.488L27.945,-22.353ZM-0.715,-99.393L-16.364,-83.763L25.081,-42.002L58.027,-42.018L-0.715,-99.393Z"
                  style={{ fill: 'white' }}
                />
              </g>
            </g>
            <g transform="matrix(-1.35019,1.00655e-15,9.31834e-16,1.39278,3456.3,-383.563)">
              <path
                d="M2331.33,442.725L2331.29,421.263L2265.5,357.31L2143.94,357.31L2058.4,440.228L2080.38,440.228L2151.82,370.969L2257.31,370.969L2331.33,442.725Z"
                style={{ fill: 'rgb(77,147,120)' }}
              />
            </g>
            <g transform="matrix(-1.90673,-3.83968e-16,1.40895,-1.40895,4089.85,847.826)">
              <path
                d="M2145.81,357.31L2265.5,357.31L2265.5,370.969L2145.69,370.969L2098.92,307.672L2109.13,307.672L2145.81,357.31Z"
                style={{ fill: 'rgb(77,147,120)' }}
              />
            </g>
            <g transform="matrix(-1.77519,1.77519,-3.05298e-16,-2.17256,4581.84,-2892.88)">
              <path
                d="M2265.5,370.997L2209.56,370.969L2209.56,357.31L2254.92,357.31L2254.92,320.224L2265.5,328.969L2265.5,370.997Z"
                style={{ fill: 'rgb(77,147,120)' }}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="_Linear2"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.16861e-12,322.587,-322.587,2.16861e-12,473.448,-83.8248)"
      >
        <stop offset="0" style={{ stopColor: 'rgb(77,147,134)', stopOpacity: '1' }} />
        <stop offset="1" style={{ stopColor: 'rgb(77,147,134)', stopOpacity: '0' }} />
      </linearGradient>
    </defs>
  </svg>,
  'LayoutLogoIcon',
);
